(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  setTimeout(function() {
    $(".shopify-section .apps").prependTo(".cart__input-buttons")
  }, 100)

  } catch(e) { console.error(e); }
})();
})();
